import { render, staticRenderFns } from "./TermSetup.vue?vue&type=template&id=73e52b31&"
import script from "./TermSetup.vue?vue&type=script&lang=js&"
export * from "./TermSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports